var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 39,
    viewBox: "0 0 29 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3636 21.2727H5.63635V23.0454H23.3636V21.2727Z",
    fill: "#757474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3636 26.5908H5.63635V28.3635H23.3636V26.5908Z",
    fill: "#757474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2727 5.31812H5.63635V7.09084H16.2727V5.31812Z",
    fill: "#757474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3636 31.9092H5.63635V33.6819H23.3636V31.9092Z",
    fill: "#757474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3636 15.9546H5.63635V17.7273H23.3636V15.9546Z",
    fill: "#757474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.822 39C27.822 39 28.6818 39 28.6818 38.1331V7.8L20.9456 0H1.17795C1.17795 0 0.318176 0 0.318176 0.866864V38.1314C0.318176 39 1.17795 39 1.17795 39H27.822ZM2.0909 1.77273H19.8182V7.09091C19.8182 8.86364 21.5909 8.86364 21.5909 8.86364H26.9091V37.2273H2.0909V1.77273Z",
    fill: "#757474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3636 10.6365H5.63635V12.4092H23.3636V10.6365Z",
    fill: "#757474"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/File icon.d5fc8ae256a9b706be45dccb602fdf6e.svg";
export { ForwardRef as ReactComponent };